import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { EMessageLevel, IMessageUi } from '../../domain/message-ui.model';
import { UUID } from '@okcargo-apps/shared-domain';
import { MessagesUiService } from '../../application/message-ui.service';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ClickStopPropagationDirective } from '@okcargo-apps/ng-utils';

@Component({
  selector: 'lib-message-ui-material-card',
  imports: [MatIcon, MatIconButton, MatButton, ClickStopPropagationDirective],
  templateUrl: './message-ui-material-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './message-ui-material-card.component.scss',
})
export class MessageUiMaterialCardComponent {
  messages = input.required<IMessageUi[]>();

  actionTriggered = output<{ messageId: UUID; data?: unknown }>();

  private readonly messagesUiService = inject(MessagesUiService);

  protected readonly EMessageLevel = EMessageLevel;

  public removeMessage(messageId: UUID): void {
    console.log('remove message!!!!!!');
    this.messagesUiService.removeMessageById(messageId);
  }

  protected onActionClick(message: IMessageUi): void {
    this.actionTriggered.emit({
      messageId: message.id,
      data: message.action?.data,
    });
  }
}
